module.exports = __webpack_public_path__ + "img/dcs_pic_3.90070a32.jpg";